import type { IService } from "@designboticteam/core";
import type { WmsSource } from "../MapStoreService";
import type { PmTilesSourceDefinition } from "../MapStoreService/PmTilesService/types";

type MapConfig = {
	origin: [number, number];
	zoom: number;
	style: string;
	hash?: boolean;
	pmTilesSources?: Array<PmTilesSourceDefinition>;
	wmsSources?: Array<WmsSource>;
	isParcelsListEnabled?: boolean; // The in-view parcels list walks the archive in a worker; only apps that show the list should pay for it
};

const DEFAULT_CONFIG: MapConfig = {
	origin: [0, 0],
	zoom: 1,
	style: "default",
};

class MapConfigService implements IService, MapConfig {
	public readonly serviceName = "MapConfigService";

	public readonly origin: [number, number];
	public readonly zoom: number;
	public readonly style: string;
	public readonly hash?: boolean;
	public readonly pmTilesSources?: Array<PmTilesSourceDefinition>;
	public readonly wmsSources?: Array<WmsSource>;
	public readonly isParcelsListEnabled: boolean;

	constructor(config?: MapConfig) {
		this.origin = config?.origin ?? DEFAULT_CONFIG.origin;
		this.zoom = config?.zoom ?? DEFAULT_CONFIG.zoom;
		this.style = config?.style ?? DEFAULT_CONFIG.style;
		this.hash = config?.hash;
		this.pmTilesSources = config?.pmTilesSources;
		this.wmsSources = config?.wmsSources;
		this.isParcelsListEnabled = config?.isParcelsListEnabled ?? false;
	}

	public initialize(): void {}
	public dispose(): void {}
}

export { type MapConfig, MapConfigService };
